import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		display: "flex",
		backgroundColor: colors.purple3,
		flexDirection: "column",
		paddingRight: 32,
		paddingLeft: 32,
		paddingBottom: 20,
		"@media print": {
			backgroundColor: colors.purple3,
			border: `1px solid ${colors.purple3}`,
			pageBreakAfter: "auto",
		},
	},
	promptContainer: {
		color: colors.black7,
		fontFamily: "freight-sans-pro",
		fontSize: 15,
		paddingTop: 16,
		paddingBottom: 12,
		textAlign: "center",
	},
	resolutionContainer: {
		backgroundColor: colors.purple4,
		color: colors.black7,
		fontFamily: "freight-sans-pro",
		fontSize: 15,
		paddingTop: 12,
		paddingBottom: 12,
		paddingLeft: 12,
		paddingRight: 12,
		textAlign: "center",

		"white-space": "pre-wrap",
		"word-wrap": "break-word",

		minHeight: 20, // necessary for IE >:(
		boxSizing: "border-box",

		[breakpoints.mobileOnly]: {
			width: "100%",
		},

		"@media print": {
			backgroundColor: colors.purple4,
			border: `1px solid ${colors.purple4}`,
			pageBreakAfter: "auto",
		},
	},
});

export default class CertificateResolution extends PureComponent {
	static propTypes = {
		prompt: PropTypes.string.isRequired,
		resolution: PropTypes.string.isRequired,
	};

	render() {
		return (
			<div className={css(styles.container)}>
				<div className={css(styles.promptContainer)}>{this.props.prompt}</div>
				<div className={css(styles.resolutionContainer)}>{this.props.resolution}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CertificateResolution.js